import { httpGet, httpPost, httpPut } from "@/request/http";

let path = "/lineOA";

export default {
  getManagement() {
    return httpGet(`/businesses${path}/managementType`);
  },
  saveManagement(item) {
    return httpPut(`/businesses${path}/managementType`, item);
  },
  getCompany() {
    return httpGet(`/businesses${path}`);
  },
  getCompanySettings() {
    return httpGet("/businesses/line-settings");
  },
  putCompanySettings(item) {
    return httpPut("/businesses/line-settings", item, {
      meta: { preserveEmptyStrings: true },
    });
  },
  getCompanyImage() {
    return httpGet("/businesses/line-image");
  },
  saveCompanyLineOAName(item) {
    return httpPut(`/businesses${path}/name`, item);
  },
  getStores() {
    return httpGet(`/devices${path}Name`);
  },
  saveStoreLineOAName(id, item) {
    return httpPut(`/devices/${id}${path}Name`, item);
  },
  saveCompanyImage(item) {
    return httpPost("/businesses/line-image", item);
  },
  saveCompanySetting(item) {
    return httpPut("/businesses/line-setting", item);
  },
};
